import React, { Fragment, useCallback, useEffect, useState } from 'react'
import DashHomeActiveUser from './DashHomeActiveUser'
import axios from 'axios';
import { useResponsive } from '../../hooks/use-responsive';
import NoPlanSelected from './NoPlanSelected';
import DashHomeNotActiveUser from './DashHomeNotActiveUser';
import MegaLoader from '../../components/MegaLoader ';

export default function DashHome() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;
  const mdUp = useResponsive("up", "md");
  const [userDetails, setUserDetails] = useState(null)
  const [loading, setLoading] = useState(false);

  const fetchUserData = useCallback(async () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const response = await axios.get(GET_USER, config, { withCredentials: true, });
      setUserDetails(response.data.user)
    } catch (error) {
      console.log("error response", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, []);

  if (loading || userDetails === null) {
    // Show loader while data is being fetched or if userDetails is not yet set
    return <MegaLoader loading={loading} />;
  }

  return (
    <Fragment>
      {userDetails && userDetails?.paymentDetails?.paymentId === "free_trial" ?
        <DashHomeNotActiveUser userDetails={userDetails && userDetails} /> :
        !userDetails?.paymentDetails?.paymentId  ? <NoPlanSelected /> :<DashHomeActiveUser  userDetails={userDetails && userDetails} /> 
      }


    </Fragment>
  )
}
